/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimPaymentDetailPayloadDto
 */
export interface ClaimPaymentDetailPayloadDto {
    /**
     * Loss type
     * @type {string}
     * @memberof ClaimPaymentDetailPayloadDto
     */
    lossType: ClaimPaymentDetailPayloadDtoLossTypeEnum;
    /**
     * This Payment (100% FGU)
     * @type {string}
     * @memberof ClaimPaymentDetailPayloadDto
     */
    thisPayment100Fgu?: string;
    /**
     * This Payment (100% Our Layer)
     * @type {string}
     * @memberof ClaimPaymentDetailPayloadDto
     */
    thisPayment100Layer?: string;
    /**
     * This Payment - GST (100% Our Layer)
     * @type {string}
     * @memberof ClaimPaymentDetailPayloadDto
     */
    thisPaymentGst100Layer?: string;
    /**
     * Outstanding (100% Our Layer)
     * @type {string}
     * @memberof ClaimPaymentDetailPayloadDto
     */
    outstanding100Layer?: string;
}


/**
 * @export
 */
export const ClaimPaymentDetailPayloadDtoLossTypeEnum = {
    Indemnity: 'Indemnity',
    LossAdjusterCosts: 'Loss Adjuster Costs',
    ConsultantCosts: 'Consultant Costs',
    LegalCosts: 'Legal Costs',
    RiCosts: 'RI Costs'
} as const;
export type ClaimPaymentDetailPayloadDtoLossTypeEnum = typeof ClaimPaymentDetailPayloadDtoLossTypeEnum[keyof typeof ClaimPaymentDetailPayloadDtoLossTypeEnum];


/**
 * Check if a given object implements the ClaimPaymentDetailPayloadDto interface.
 */
export function instanceOfClaimPaymentDetailPayloadDto(value: object): value is ClaimPaymentDetailPayloadDto {
    if (!('lossType' in value) || value['lossType'] === undefined) return false;
    return true;
}

export function ClaimPaymentDetailPayloadDtoFromJSON(json: any): ClaimPaymentDetailPayloadDto {
    return ClaimPaymentDetailPayloadDtoFromJSONTyped(json, false);
}

export function ClaimPaymentDetailPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimPaymentDetailPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'lossType': json['lossType'],
        'thisPayment100Fgu': json['thisPayment100Fgu'] == null ? undefined : json['thisPayment100Fgu'],
        'thisPayment100Layer': json['thisPayment100Layer'] == null ? undefined : json['thisPayment100Layer'],
        'thisPaymentGst100Layer': json['thisPaymentGst100Layer'] == null ? undefined : json['thisPaymentGst100Layer'],
        'outstanding100Layer': json['outstanding100Layer'] == null ? undefined : json['outstanding100Layer'],
    };
}

export function ClaimPaymentDetailPayloadDtoToJSON(json: any): ClaimPaymentDetailPayloadDto {
    return ClaimPaymentDetailPayloadDtoToJSONTyped(json, false);
}

export function ClaimPaymentDetailPayloadDtoToJSONTyped(value?: ClaimPaymentDetailPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lossType': value['lossType'],
        'thisPayment100Fgu': value['thisPayment100Fgu'],
        'thisPayment100Layer': value['thisPayment100Layer'],
        'thisPaymentGst100Layer': value['thisPaymentGst100Layer'],
        'outstanding100Layer': value['outstanding100Layer'],
    };
}

